<template>
    <form class="login" @submit.prevent="ParolaSifirla">
        <h4>{{$t('Giris.1')}}</h4>
        <div class="form-group" :class="{ 'is-invalid': hata.email }">
            <input class="form-control" v-model="user.email" type="email">
            <label class="form-label">{{$t('Giris.4')}}</label>
            <label class="error" v-if="hata.email">{{hata.email}}</label>
        </div>
        <div class="form-group">
            <router-link to="/giris" class="hesap text-mavi float-left">{{$t('Giris.2')}}</router-link>
            <button type="submit" class="btn btn-mavi float-right"> {{$t('Giris.10')}}</button>
        </div>
        <div class="clearfix"></div>
    </form>
</template>
21£>
<script>
    export default {
        data() {
            return {
                user: {
                    email: this.$route.query.email
                },
                hata: {
                    email: null
                },
            }
        },
        methods: {
            ParolaSifirla() {
                if (!this.user.email) this.hata.email = this.$t('Hata.1'); else this.hata.email = null;
                if (!this.hata.email) {
                    this.$store.dispatch("Login", {...this.user, path: 'giris/sifirla'})
                        .then(response => {
                            if (response.Durum == "OK") {

                                this.$message.success(response.Mesaj)

                            } else {
                                this.$message.error(response.Mesaj)
                                this.hata = response.Hata;

                            }
                            //console.log(response)
                        })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Giris/parola.vue